let define = require('../utils/define');
module.exports = {
    apiURI: define.APIURl,
    devURI: process.env.NODE_ENV === 'development' ? "/dev" : ''
}
